import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-ship-cover-insurance';

export default function Example() {
  return (
    <>
      <Head>
        <title>eBay ShipCover Insurance: Coverages and How To File Claims</title>
        <meta
          name='description'
          content="As much as sellers want to avoid parcel loss or damages, accidents happen. Thankfully, eBay has insurance that can protect you–here's how."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-ship-cover-insurance' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-ship-cover-insurance' />
        <meta property='og:title' content='eBay ShipCover Insurance: Coverages and How To File Claims' />
        <meta
          property='og:description'
          content="As much as sellers want to avoid parcel loss or damages, accidents happen. Thankfully, eBay has insurance that can protect you–here's how."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='April 8th, 2022' />
        <meta property='article:modified_time' content='April 8th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
